import supabase from 'modules/core/supabase/supabase';
import { DeviceDto } from 'modules/core/supabase/tables/device';

export class DevicesRepository {
  async list(params: { tournament_id: number; offset?: number; limit?: number; name?: string }): Promise<DeviceDto[]> {
    return supabase.device.list(params);
  }

  async create(params: { name: string; tournament_id: number }): Promise<DeviceDto> {
    return supabase.device.create(params) as Promise<DeviceDto>;
  }

  async update(id: number, params: Partial<{ name: string; tournament_id: number }>): Promise<DeviceDto> {
    return supabase.device.update(id, params) as Promise<DeviceDto>;
  }

  async delete(id: number): Promise<boolean> {
    return supabase.device.delete(id);
  }
}

const devicesRepository = new DevicesRepository();
export default devicesRepository;
